import {IllegalArgumentError, IllegalStateError} from '../error/common-errors.class';
/**
 * Created by Rodrigo Quesada on 13/01/17.
 */

export function checkThat(condition: Boolean, message: () => string) {
    if (!condition) throw new IllegalArgumentError(message());
}

export function requireThat(condition: Boolean, message: () => string) {
    if (!condition) throw new IllegalStateError(message());
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/common/typescript/preconditions.util.ts